<template>
  <div
    class="uploader-container d-flex flex-column justify-center align-center blue-grey lighten-3"
    :class="{
      'uploader-container--dragging': isDraggingFile,
    }"
  >
    <v-icon :color="isDraggingFile ? 'blue' : 'blue-grey'" large>
      mdi-image-plus
    </v-icon>

    <v-spacer class="mt-3 flex-grow-0" />

    <h3 class="blue-grey--text text--darken-3 text-center subtitle-2">
      {{ $t('media.drop_images_message') }}
    </h3>

    <p class="mb-0 blue-grey--text caption">{{ $t('common.or') }}</p>

    <v-spacer class="mb-2 flex-grow-0" />

    <Button
      color="primary"
      :text="$t('media.browse_files_button')"
      @click="$emit('select')"
    />

    <p class="mt-3 mb-0 blue-grey--text text-overline text-center">
      {{ $constants.images.acceptedExtensions.join(',') }}
    </p>
  </div>
</template>

<script>
import Button from '@/components/UI/Button'
export default {
  name: 'MediaContainerMainUploader',
  components: {
    Button,
  },
  props: {
    isDraggingFile: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.uploader-container {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.2s;

  &--dragging {
    background-color: var(--v-blue-lighten5);
    border-color: var(--v-primary-base);
  }
}
</style>
